import { createActions, createReducer } from "reduxsauce"

export const { Types, Creators } = createActions({
  expandFacet: ["facetType"],
  close: [],
  reset: [],
}, {
  prefix: "ompnt/modules/securities-finder-facets/",
})

const DEFAULT_STATE = {
  country: {},
  currency: {},
  classifications: {},
  expanded: null,
}

function handleExpandFacet(state, { facetType }) {
  return { ...state, expanded: facetType }
}

function handleClose(state) {
  return { ...state, expanded: null }
}

function handleReset(state) {
  return { ...state, ...DEFAULT_STATE }
}

export default createReducer(DEFAULT_STATE, {
  [Types.EXPAND_FACET]: handleExpandFacet,
  [Types.CLOSE]: handleClose,
  [Types.RESET]: handleReset,
})
